export const DEFAULT_TOOLTIP_Z_INDEX = "99999999999999";
//# sourceMappingURL=constant.js.map
